// extracted by mini-css-extract-plugin
export default {"projectStatus":"ProjectStatus_projectStatus__rcTNK"};